export class PanelMediaStyle {
  width: number;
  height: number;
  border = '';
  boxShadow = '';
  hoverBoxShadow = '';
  boxDecoration = '';
  transition = '';
  marginTop = 'uk-margin-remove-top';

  static normalize(styles: Partial<PanelMediaStyle>): PanelMediaStyle {
    const pureStyles = new PanelMediaStyle();

    pureStyles.width = styles.width ?? pureStyles.width;
    pureStyles.height = styles.height ?? pureStyles.height;
    pureStyles.border = styles.border ?? pureStyles.border;
    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;
    pureStyles.hoverBoxShadow = styles.hoverBoxShadow ?? pureStyles.hoverBoxShadow;
    pureStyles.boxDecoration = styles.boxDecoration ?? pureStyles.boxDecoration;
    pureStyles.transition = styles.transition ?? pureStyles.transition;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
